import React from 'react'
import { Grid, Box, Button, Typography, Checkbox, Tooltip } from '@material-ui/core'
import moment from 'moment'
import { AttachFile } from '@material-ui/icons'
import numeral from 'numeral'

// Components
import TextField from 'StandardComponents/CustomTextfield/CustomTextField'
import AutoComplete from 'StandardComponents/AutoCompleteTextfield/AutoCompleteTextfield'
import Select from 'StandardComponents/CustomedSelect/CustomedSelect'
import TextFieldCurrency from 'StandardComponents/TextFieldCurrency/TextFieldCurrency'
import UploadButton from 'StandardComponents/CustomUploadButton/CustomUploadButton'
import Radio from 'StandardComponents/CustomedRadioButton/CustomedRadioButton'

import classes from './CreateLiquidation1stPage.module.scss'

export default function CreateLiquidation1stPage(props) {
  const {
    fileError,
    setFileError,
    setButtonColor,
    buttonColor,
    handleOnChangeCAStatus,
    isCAStatus,
    setSelectedFile,
    onClickAutoComplete,
    onChangeAutoComplete,
    setSuggestionsVatType,
    value,
    suggestionsVendor,
    suggestionsRequestingDepartment,
    setSuggestionsWtaxRate,
    setSuggestionsRequestingDepartment,
    setSuggestionsProject,
    suggestionsProjects,
    handleOnchange,
    handleDownloadAttachment,
    handleOnChangeSelect,
    params,
    setValue,
    setSuggestionsVendors,
    errors
  } = props

  const handleOnChangeFile = event => {
    if (event.target.name === 'file' && event.target.files.length !== 0) {
      let fileName = event.target.files[0].name.split('.')
      let fileExtension = fileName[fileName.length - 1]
      setValue({ ...value, file: event.target.files[0], selectedFile: event.target.files[0].name })
      setSelectedFile({
        file: event.target.files[0].name
      })
      if (fileExtension !== 'pdf') {
        setFileError('wrong')
      } else {
        setFileError('correct')
      }
    }
  }

  return (
    <React.Fragment>
      <Box className={classes.root}>
        <Typography style={{ fontWeight: 'Bold', fontSize: '20px', marginBottom: '20px' }}>Cash Advances Information</Typography>
        <Grid container direction='row' style={{ marginLeft: '20px' }}>
          <Grid item sm={5} xs={5}>
            <TextField
              constainerStyle={{ width: '100%' }}
              value={moment(value.dueDate).format('MM/DD/YYYY')}
              placeholder={'Enter sub project...'}
              readOnly
              label='Due Date'
            />
          </Grid>
          <Grid item sm={5} xs={5}>
            <AutoComplete
              label='Vendor/Payee'
              constainerStyle={{ width: '100%', height: '100%', overflow: 'auto' }}
              value={value.vendor}
              readOnly
              onClick={() => {
                onClickAutoComplete({
                  name: 'vendor',
                  value: value,
                  setSuggestions: setSuggestionsVendors,
                  setSuggestionsVatType: setSuggestionsVatType,
                  params: params
                })
              }}
              suggestions={suggestionsVendor}
              onChange={(event, isClick) => {
                onChangeAutoComplete({
                  event: event,
                  isSuggestionClick: isClick,
                  name: 'vendor',
                  setSuggestionsWtaxRate: setSuggestionsWtaxRate,
                  setSuggestionsVatType: setSuggestionsVatType,
                  value: value,
                  params: params,
                  setSuggestion: setSuggestionsVendors,
                  suggestion: suggestionsVendor,
                  setValue: setValue
                })
              }}
              error={errors.vendor}
            />
          </Grid>
          <Grid item sm={5} xs={5}>
            <Select
              label='Requesting Department'
              constainerStyle={{ width: '100%', height: '100%', overflow: 'auto' }}
              value={value.department}
              name={'department'}
              readOnly
              suggestions={suggestionsRequestingDepartment}
              onChange={handleOnChangeSelect}
              onClick={() => {
                onClickAutoComplete({
                  name: 'department',
                  value: value,
                  setSuggestions: setSuggestionsRequestingDepartment,
                  params: params
                })
              }}
            />
          </Grid>
          <Grid item sm={5} xs={5}>
            <TextField
              constainerStyle={{ width: '100%' }}
              value={value.particulars}
              placeholder={'Enter particulars...'}
              readOnly
              name='particulars'
              onChange={value => handleOnchange(value, 'particulars')}
              label='Particulars'
              required
              error={errors.particulars}
            />
          </Grid>
          <Grid itemsm={5} xs={5}>
            <AutoComplete
              label='Projects'
              constainerStyle={{ width: '100%', height: '100%', overflow: 'auto' }}
              value={value.project}
              readOnly
              onClick={() => {
                onClickAutoComplete({
                  name: 'project',
                  value: value,
                  setSuggestions: setSuggestionsProject,
                  params: params
                })
              }}
              suggestions={suggestionsProjects}
              onChange={(event, isClick) => {
                onChangeAutoComplete({
                  event: event,
                  isSuggestionClick: isClick,
                  name: 'project',
                  value: value,
                  params: params,
                  setSuggestion: setSuggestionsProject,
                  suggestion: suggestionsProjects,
                  setValue: setValue
                })
              }}
              error={errors.project}
            />
          </Grid>
          <Grid item container sm={5} xs={5} style={{ marginBottom: '30px' }}>
            <TextField
              label='Amount'
              readOnly
              value={`₱ ${numeral(value.amount).format('0,0.00')}`}
              onChange={value => handleOnchange(value, 'amount')}
            />
          </Grid>
          {value.status === 'Returned' ? ('') : (
            <Grid item xs={12} sm={12}>
              <Box className={classes.view_download_container}>
                <Button onClick={handleDownloadAttachment} className={classes.button}><AttachFile className={classes.icon} />View Attached File</Button>
                <Typography className={classes.filename}>{value.selectedFile2}</Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
      <Box className={classes.root_liquidation}>
        <Typography className={classes.header}>Liquidation Information</Typography>
        <Grid container constainer style={{ marginLeft: '20px', marginRight: '70px' }}>
          <Grid item xs={5}>
            <Box style={{ display: 'flex', marginTop: '20px', marginBottom: '30px' }}>
              <Typography className={classes.check_box_label}>Partial:</Typography>
              <Tooltip title={'If checked the status will be "Partial"'}>
                <Checkbox
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                  checked={isCAStatus}
                  onChange={handleOnChangeCAStatus}
                />
              </Tooltip>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <div className={classes['file-upload-container']}>
              <UploadButton
                style={{ marginBottom: '30px' }}
                placeholder={'Upload ATD (Authority to Deduct) must be a pdf file....'}
                onChange={handleOnChangeFile}
                value={value.selectedFile}
                fileError={fileError}
                setButtonColor={setButtonColor}
                buttonColor={buttonColor}
                readOnly
                setFileError={setFileError}
                setSelectedFile={setSelectedFile}
                error={errors.selectedFile}
              />
            </div>
          </Grid>
        </Grid>
      </Box>
    </React.Fragment >
  )
}
